import { select, takeLatest } from 'redux-saga/effects';
import { CHANGE_LOCALE } from './constants';
import { getLocaleSelector } from './selectors';

const LOCALE_KEY = 'locale';

export function* watchChangeLocale() {
  yield takeLatest(CHANGE_LOCALE, changeLocale);
}

export function* changeLocale() {
  const locale = yield select(getLocaleSelector);
  localStorage.setItem(LOCALE_KEY, locale);
}

export default [watchChangeLocale];
